import styled from 'styled-components'
import { ButtonStyleType } from 'src/types/type'
import { COLOR } from 'src/service/utils/constant/color'

const JoinSubmitWrap = styled.div`
  max-width: 492px;
  width: 100%;
  margin: 28px auto 15px auto;
  display: block;
`
const CustomBtn = styled.button<ButtonStyleType>`
  display: block;
  border: none;
  max-width: 456px;
  width: 100%;
  margin: 0 auto 10px auto;
  background-color: ${props => props.disabled? '#eee':props.backgroundColor};
  //background-color: ${(props) => props.backgroundColor};
  font-size: ${props => props.fontSize};
  color: ${props => props.fontColor ?? '#fff'};
  font-weight: ${props => props.fontWeight ?? 400};
  border-radius: ${props => props.borderRadius};
  letter-spacing: ${props => props.letterSpacing};
  height: 54px;
  line-height: 54px;
  @media all and (max-width: 492px) {
    width: 93%;
  }
`
const CustomButton = styled.button<
    {
        fontSize?: string,
        fontFamily?: string,
        width?: string,
        height?: string,
        bgColor?: string,
        borderColor?: string,
        color?: string,
        borderRadius?: string,
        marginTop?: string
    }>`
  display: flex;
  justify-content: center;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border: ${(props) => props.borderColor !== undefined ? `1px solid ${props.borderColor}` : "none"};
  margin: ${(props) => `${props.marginTop} auto 0 auto`};
  background: ${(props) => props.disabled? COLOR.blueGray1 : props.bgColor};
  color: ${(props) => props.color};
  padding: 0;
  border-radius: ${(props) => props.borderRadius};
  pointer-events: ${(props) => props.bgColor === COLOR.gray30 && "none"};

  &.health_btn_mo {
    > img {
      width: 16px;
      height: 16px;
      margin: 15px 5px 15px 0;
      display: block;
    }
  }

  &.health_btn_pc {
    > img {
      width: 16px;
      height: 16px;
      margin: 20px 5px 20px 0;
      display: block;
    }
  }

  > span, > a {
    text-align: center;
    color: ${(props) => props.color};
    line-height: ${(props) => props.height};
    font-family: ${(props) => props.fontFamily};
    font-size: ${(props) => props.fontSize};
  }
`


const NoticeFeeText = styled.p<{fontColor: string, fontSize: string, cashSpace: string}>`
  margin: 5px auto 0 auto;
  width: 93%;
  word-break: keep-all;
  text-align: center;
  font-weight: 700;
  font-size: ${props => props.fontSize};
  letter-spacing: ${props => props.cashSpace};
  color: ${(props) => props.fontColor};
`

export { JoinSubmitWrap, CustomBtn, CustomButton, NoticeFeeText }
